import React, { Component } from 'react';
import { onUnsubClick } from '../../../utils/helper'


class FrFooter extends Component {
    render() {
        const uid = JSON.parse(sessionStorage.getItem('uid'));
        return (
            window.location.host.split('.')[0] == 'dz' ?
                <div >
                    <a href='' onClick={onUnsubClick} target="_blank">Se désabonner</a>
                </div> :
                <div >
                    <a href="http://fr.mobioastro.com/" target="_blank">Accueil</a> | <a href="http://n.mobioastro.com/fr/tnc-mobioastro?offer=1&device=pc&_next=general_conditions.html" target="_blank">Termes et conditions</a> | <a href='' onClick={onUnsubClick} target="_blank">Se désabonner</a>
                </div>

        );
    }
}

export default FrFooter;


// WEBPACK FOOTER //
// ./src/mobioastro/components/footer/frfooter.js